import ApiService from "../../apiService";

class ApiConsumer {
  static async getIcd(inputValue) {
    if (inputValue.length >= 3) {
      const response = await ApiService.get(
        "management/icd10/read?keyword=" + inputValue
      );
      return response.code === 200
        ? response.data.data.map((data) => {
            return {
              value: data.id,
              label: `${data.code} - ${data.name}`,
              case: "new",
              code: data.code,
              name: data.name,
            };
          })
        : [];
    }
  }

  static async getTreatment(paymentType, inputValue) {
    const response = await ApiService.get(
      `/management/treatments_price/read?payment_type=${paymentType}&keyword=${inputValue}`
    );
    return response.code === 200
      ? response.data.map((data) => {
          return {
            value: data.treatment_id,
            label: `${data.payment_type_id} - ${data.treatment.name} - (${data.price})`,
          };
        })
      : [];
  }

  static async getTeethAnamneseByPatient(id) {
    const response = await ApiService.get(
      `/management/teeth_anamneses/search/${id}`
    );
    return response.code === 200 ? response.data : [];
  }

  static async getRefTeeth() {
    const response = await ApiService.get("/management/teeths/read");
    return response.code === 200 ? response.data : [];
  }
}

export default ApiConsumer;
